import DateInput from '../inputs/DateInput';
import createField from './createField';

const DateField = createField(DateInput);

export default DateField;
